'use strict';
import assign from 'lodash/assign';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';


export function ActivityFeedDomainProvider() {
  return {
    $get: [
      '$log',
      'AbstractDomainClass',
      '$filter',
      '$translate',
      'fetchUtils',
      function (
        $log,
        AbstractDomainClass,
        $filter,
        $translate,
        fetchUtils,
      ) {
        function ActivityFeedDomain(data) {
          AbstractDomainClass.call(this, ActivityFeedDomain, data);
        }

        AbstractDomainClass.__inheritFrom(ActivityFeedDomain, 'ActivityFeedDomain', 'activity-feed');

        ActivityFeedDomain.$constraints.addConstraints({
          type: {type: 'string'},
          msg: {type: 'string'}, // i18n message code
          data: {type: 'JSON', nullable: true}, // i18n message parameters
          feedable: {type: 'DomainLink', nullable: true},
          feedTarget: {type: 'DomainLink', nullable: true},
          uri: {type: 'string', nullable: true},
          metadata: {type: 'JSON', nullable: true}, // contains appState and potentially other relevant data
          date: {type: 'Date'}
        });

        // more methods go here;

        ActivityFeedDomain.getFeedTarget = getFeedTarget;
        ActivityFeedDomain.processEntryData = processEntryData;

        function getFeedTarget(entry) {
          return isUndefined(entry.feedTarget) || entry.feedTarget === true ? entry.feedable : entry.feedTarget;
        }

        /**
         * This method will take an activity feed entry's data object and format any dates and call the linkCallback
         * function on any links so they can be retrieved and converted to strings
         *
         * @param {Object} model
         * @param {string} model.id
         * @param {Object} model.data
         * @param linkCallback - will be passed a link object. must return a promise
         * @param {Object} modelParentLink
         * @param {string} modelParentLink.id
         * @param {string} modelParentLink.collection
         * @returns {*}
         */
        function processEntryData(model, linkCallback, modelParentLink) {
          var dataObj = assign({}, model.data, {
            feedable: model.feedable,
            feedTarget: ActivityFeedDomain.getFeedTarget(model),
          });
          var promises = [];
          var flattenedObj = {};
          var updateEntry = false;

          if (dataObj !== null && isObject(dataObj)) {
            for (var key in dataObj) {
              if (dataObj.hasOwnProperty(key)) {
                var item = dataObj[key];

                if (!isObject(item)) {
                  flattenedObj[key] = item;

                } else {
                  if (item.hasOwnProperty('date')) {
                    flattenedObj[key] = $filter('date')(new Date(item.date), item.time ? 'medium' : 'mediumDate');

                  } else if (item.hasOwnProperty('msg')) {
                    promises.push(_translateMesage(flattenedObj, key, item.msg));
                  } else if (linkCallback && item.hasOwnProperty('id') && item.hasOwnProperty('collection')) {

                    var linkCallbackResult = linkCallback(item);

                    if (isString(linkCallbackResult)) {
                      flattenedObj[key] = linkCallbackResult;
                      if (coerceToNull(item.value) !== coerceToNull(linkCallbackResult)) {
                        if (linkCallbackResult === null || isUndefined(linkCallbackResult)) {
                          flattenedObj[key] = item.value;
                        } else {
                          updateEntry = true;
                        }
                      }

                    } else if (linkCallbackResult && linkCallbackResult.then) {
                      promises.push(linkCallbackResult.then(_linkHandler(flattenedObj, key)).then((function resolveLinkValue(itemKey, itemValue) {
                        if (coerceToNull(itemValue) !== coerceToNull(flattenedObj[itemKey] && flattenedObj[itemKey].toString())) {
                          if (flattenedObj[itemKey] === null || isUndefined(flattenedObj[itemKey])) {
                            flattenedObj[itemKey] = itemValue;
                          } else {
                            updateEntry = true;
                          }
                        }
                      }).bind(null, key, item.value)));

                    } else {
                      $log.warn('invalid callback result for link:', item);
                      $log.warn('result:', linkCallbackResult);
                    }

                  } else if (item.hasOwnProperty('value')) {
                    // used when the target object has been deleted. Only a value will remain
                    flattenedObj[key] = item.value;

                  } else { // this object is not yet supported. Log it so it can caught in testing
                    $log.warn('Unsupported activity feed data property ' + key + ' with value ', item);
                    flattenedObj[key] = item;
                  }
                }
              }
            }
          }

          return Promise.all(promises).then(function () {
            if (updateEntry) {
              _updateFeedEntry(model.id, modelParentLink.collection + '-meta/' + modelParentLink.id + '/links/feed')
            }

            //$log.debug(flattenedObj);
            return flattenedObj;
          }).catch(function (e) {
            console.error(e);
          });
        }

        function coerceToNull(value) {
          return isUndefined(value) ? null : value;
        }

        function _linkHandler(obj, key) {
          return function _linkHandlerClosure(result) {
            if (isObject(result))
              obj[key] = isFunction(result.toDescriptiveString) ? result.toDescriptiveString() : result.toString();
            else
              obj[key] = result;
          }
        }

        function _translateMesage(obj, key, msg) {
          return $translate(msg).then(function (value) {
            obj[key] = value;
          });
        }

        function _updateFeedEntry(feedId, path) {
          const request = {
            method: 'POST',
            mode: 'cors',
            cache: 'default',
            contentType: 'json',
            responseType: 'json',
            body: {path},
          };

          const url = `${fetchUtils.API_URL}/api/${ActivityFeedDomain.COLLECTION}/refresh/${feedId}`;
          return fetchUtils.requestWithAuth(url, request);
        }

        ActivityFeedDomain.prototype.toString = function () {
          return this.message;
        };

        return ActivityFeedDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/activity-feed/domain/ActivityFeedDomain.js